import { render, staticRenderFns } from "./ProjectPartsList.vue?vue&type=template&id=155c5c49&scoped=true&lang=pug&"
import script from "./ProjectPartsList.vue?vue&type=script&lang=ts&"
export * from "./ProjectPartsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectPartsList.vue?vue&type=style&index=0&id=155c5c49&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c5c49",
  null
  
)

export default component.exports